import { CREATE_COMBINATION_RESULT_SCHEMA } from "constants/validation";
import { composeCheckoutConfigsToShortLink } from "./checkout/merge";
import { validateShortLink } from "./shortLink";
import { validateSchema } from "./validate";

export const validateCommonProductCollectionCheckout = ({
  productsCollection,
  productsCheckouts,
  prices,
  products,
  coupons,
  taxRates,
  shippingRates
}) => {
  return async (commonCheckout) => {
    const validResult = await validateSchema(
      CREATE_COMBINATION_RESULT_SCHEMA,
      commonCheckout
    );

    const shortLinkCheckouts = [
      commonCheckout,
      ...Object.values(productsCheckouts).map((checkout) =>
        composeCheckoutConfigsToShortLink({
          selectedCheckout: checkout,
          commonConfig: commonCheckout.data
        })
      )
    ];

    let checkoutIndex;
    for (let index = 0; index < shortLinkCheckouts.length; index++) {
      checkoutIndex = index;
      const checkoutConfig = shortLinkCheckouts[index];

      const linkValidations = validateShortLink({
        shortLink: checkoutConfig,
        prices,
        products,
        coupons,
        taxRates,
        shippingRates
      });

      const validations = Object.values(linkValidations).reduce(
        (memo, validation) => {
          if (validation.copy) {
            memo.push(validation);
          }

          return memo;
        },
        []
      );

      if (validations.length > 0) {
        validResult.messages = validations;
        break;
      }
    }

    if (validResult.messages && checkoutIndex > 0) {
      const conflictProductUUID = Object.keys(productsCheckouts)[
        checkoutIndex - 1
      ];
      const conflictProductMatch = productsCollection.find(
        ({ uuid }) => uuid === conflictProductUUID
      );
      if (conflictProductMatch) {
        validResult.messages.unshift({
          copy: `Checkout selections are incompatible with your product: "${conflictProductMatch.title}"`
        });
      }
    }

    return validResult;
  };
};
